import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"

import ArrowRight from "../icons/arrow-right"
import IconButton from "@material-ui/core/IconButton"
import Button from "@material-ui/core/Button"
import { navigate } from "@reach/router"
import { DISPLAY_LIMIT } from "../../constants/constants"
import LinkToLpText from "../atoms/link-to-lp-text"
import { addCommas } from "../../utils/str"
import qs from "qs"

const styles = theme => ({
  root: {
    marginTop: "50px",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },

  paginationRoot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  notification: {
    marginBottom: '30px',
    width: '100%',
    lineHeight: '1.7em',
    boxSizing: 'border-box',
    fontSize: '13px',
  },

  iconBtn: {
    height: "40px",
    width: "40px",
    minWidth: "unset",
    minHeight: "unset",
    margin: "0px 4px",
    padding: "0px",

    [theme.breakpoints.down("xs")]: {
      margin: "0px 5px",
    },
    "&:hover": {
      background: "#EFF7FF",
    }
  },

  rightArrow: {
    borderTop: "solid 0.143em #181819",
    borderRight: "solid 0.143em #181819",
    width: "8.5px",
    height: "8.5px",
    transform: "rotate(45deg)",
  },

  leftArrow: {
    borderTop: "solid 0.143em #181819",
    borderLeft: "solid 0.143em #181819",
    width: "8.5px",
    height: "8.5px",
    transform: "rotate(-45deg)",
  },

  pages: {
    display: "flex",
    padding: 0,
    margin: 0,
    "& li": {
      listStyle: "none",
      position: "relative",
    },

    "& button": {
      fontSize: "16px",
      padding: "4px 14px",
      background: "#FFFFFF",
      margin: "0 3px",
      boxSizing: "border-box",
      minWidth: "unset",
      borderRadius: "2px",

      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
        padding: "1px 7px",
        margin: "0px 2px",
      },

      "&:hover": {
        background: "#EFF7FF",
        "&:before": {
          content: '""',
          width: "100%",
          height: "100%",
          position: "absolute",
          left: 0,
          top: 0,
          pointerEvents: "none",
        },
      },
    },
  },

  dot: {
    background: "none !important",
    border: "none !important",
    pointerEvents: "none",
    margin: "auto",
  },

  currentPage: {
    pointerEvents: "none",
    color: "#FFFFFF !important",
    background: "#1866FF !important",
  },

  desc: {
    fontSize: '12px',
    color: "#71737B",
    marginTop: '13px',
  }
})

class Pagination extends React.Component {
  goToPage = page => () => {
    navigate(
      `/${this.props.path}?${qs.stringify(
        { ...this.props.params, page: page },
        { encode: false, arrayFormat: "indices" }
      )}`
    )
  }

  calcLastPage = () => {
    const { perPage, lastPage, total } = this.props
    if (total <= DISPLAY_LIMIT) {
      return lastPage
    } else {
      return Math.floor(DISPLAY_LIMIT / perPage)
    }
  }

  renderPageBtn = page => {
    const { classes, currentPage } = this.props

    return (
      <li key={page}>
        <Button
          onClick={this.goToPage(page)}
          className={currentPage === page ? classes.currentPage : ""}
        >
          {page}
        </Button>
      </li>
    )
  }

  render() {
    const { classes, disabled, currentPage, perPage, total, displayTotal } = this.props
    const style = this.props.style ? this.props.style : {}
    const lastPageToDisplay = this.calcLastPage()
    return (
      <div
        className={classes.root}
        style={{
          ...style,
          pointerEvents: disabled ? "none" : "auto",
        }}
      >
        <div className={classes.notification}>
          <div>本サイトでは一部の情報を閲覧することができます。</div>
          <div>また、Keyman Letterに登録すると全ての情報が閲覧できるだけでなく、業界・売上高・従業員数に加え、決裁者の所属部門・役職などの詳しい条件で絞り込み検索をすることができます。<LinkToLpText/></div>
        </div>

        <div className={classes.paginationRoot}>
          {currentPage > 1 && lastPageToDisplay > 5 && (
            <IconButton
              className={classes.iconBtn}
              style={{padding: '4px 4px'}}
              onClick={this.goToPage(1)}
              aria-label="left_arrow"
            >
              <span className={classes.leftArrow}></span>
              <span className={classes.leftArrow}></span>
            </IconButton>
          )}

          {currentPage > 1 && lastPageToDisplay > 5 && (
            <IconButton
              className={classes.iconBtn}
              onClick={this.goToPage(currentPage - 1)}
              aria-label="right_arrow"
            >
              <ArrowRight style={{ transform: "rotate(180deg)" }} />
            </IconButton>
          )}

          {lastPageToDisplay  <= 5 ? (
            <ul className={classes.pages}>
              {Array.from(Array(lastPageToDisplay).keys()).map(i => this.renderPageBtn(i+1))}
            </ul>
          ) : (
            <ul className={classes.pages}>
              {currentPage > 5 && <li className={classes.dot}>⋯</li>}

              {(() => {
                let num = 0
                if (currentPage === 1) {
                  num = 0
                } else if (currentPage === 2) {
                  num = -1
                } else if (currentPage > 2 && currentPage < lastPageToDisplay - 1) {
                  num = -2
                } else if ( currentPage === lastPageToDisplay - 1) {
                  num = -3
                } else if (currentPage === lastPageToDisplay) {
                  num = -4
                }

                return Array.from(Array(5).keys()).map(i =>
                  this.renderPageBtn(currentPage + i + num)
                )
              })()}

              {currentPage < lastPageToDisplay - 2 && <li className={classes.dot}>⋯</li>}
            </ul>
          )}

          {currentPage < lastPageToDisplay && lastPageToDisplay > 5 && (
            <IconButton className={classes.iconBtn} onClick={this.goToPage(currentPage+1)} style={{ margin: '0px 3px 0px 6px'}} aria-label="right_arrow">
              <ArrowRight/>
            </IconButton>
          )}

          {currentPage < lastPageToDisplay && lastPageToDisplay > 5 && (
            <IconButton
              className={classes.iconBtn}
              style={{padding: '4px 4px'}}
              onClick={this.goToPage(lastPageToDisplay)}
              aria-label="right_arrow"
            >
              <span className={classes.rightArrow}></span>
              <span className={classes.rightArrow}></span>
            </IconButton>
          )}
        </div>

        <div className={classes.desc}>
          検索結果 {addCommas(displayTotal !== 0 ? displayTotal : total)}件中　{addCommas((currentPage-1)*perPage+1)}件目~{addCommas(currentPage*perPage <= total ? currentPage*perPage : total)}件目を表示
        </div>
      </div>
    )
  }
}

Pagination.propTypes = {
  classes: PropTypes.object.isRequired,
}

Pagination.defaultProps = {
  params: {},
  path: "",
  total: 0,
  displayTotal: 0,
}

export default withStyles(styles)(Pagination)
